/**
 * @generated SignedSource<<8498b3b99e7031d3b8a7382dca2b50d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PriceStructure = "CUSTOMIZATION_PRICE" | "FINAL_PRICE" | "SEPARATED_PRICES";
export type pricingRuleEditor_PricingDetailQuery$variables = {
  id: string;
};
export type pricingRuleEditor_PricingDetailQuery$data = {
  readonly pricing: {
    readonly id: string;
    readonly infoPricingText: string | null;
    readonly priceDescriptionEnabled: boolean | null;
    readonly priceStructure: PriceStructure | null;
    readonly pricingID: number;
    readonly pricingName: string;
    readonly products: ReadonlyArray<{
      readonly productID: number;
    } | null> | null;
    readonly quantityAsUnit: boolean | null;
    readonly rules: ReadonlyArray<{
      readonly allMatchType: boolean;
      readonly conditions: ReadonlyArray<{
        readonly conditionID: number;
        readonly formula: string;
        readonly position: number;
        readonly priceToAdd: number;
        readonly quantity: number;
      }>;
      readonly elementID: number;
      readonly elementTitle: string | null;
      readonly isSetupPrice: boolean;
      readonly priceType: number;
      readonly propertyID: number;
      readonly ruleID: number;
      readonly simplified: boolean;
      readonly targets: ReadonlyArray<{
        readonly area: string | null;
        readonly color: string | null;
        readonly side: string | null;
        readonly targetID: number;
      }>;
    }>;
  };
  readonly pricingProperties: ReadonlyArray<{
    readonly elements: ReadonlyArray<{
      readonly elementID: number;
      readonly elementName: string;
    }>;
    readonly functionName: string;
    readonly propertyID: number;
    readonly propertyName: string;
  }>;
};
export type pricingRuleEditor_PricingDetailQuery = {
  response: pricingRuleEditor_PricingDetailQuery$data;
  variables: pricingRuleEditor_PricingDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "PricingGroup",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "infoPricingText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceDescriptionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityAsUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceStructure",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingProduct",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingRule",
      "kind": "LinkedField",
      "name": "rules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleID",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elementTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSetupPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allMatchType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "simplified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingRuleCondition",
          "kind": "LinkedField",
          "name": "conditions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "conditionID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formula",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceToAdd",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingRuleTarget",
          "kind": "LinkedField",
          "name": "targets",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "targetID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "area",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "side",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "functionName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PricingPropertyElement",
  "kind": "LinkedField",
  "name": "elements",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elementName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pricingRuleEditor_PricingDetailQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PricingProperty",
        "kind": "LinkedField",
        "name": "pricingProperties",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pricingRuleEditor_PricingDetailQuery",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PricingProperty",
        "kind": "LinkedField",
        "name": "pricingProperties",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7921e03f90f6f71237a4a5aac209d018",
    "id": null,
    "metadata": {},
    "name": "pricingRuleEditor_PricingDetailQuery",
    "operationKind": "query",
    "text": "query pricingRuleEditor_PricingDetailQuery(\n  $id: ID!\n) {\n  pricing(id: $id) {\n    id\n    pricingID\n    pricingName\n    infoPricingText\n    priceDescriptionEnabled\n    quantityAsUnit\n    priceStructure\n    products {\n      productID\n    }\n    rules {\n      ruleID\n      propertyID\n      elementID\n      elementTitle\n      isSetupPrice\n      allMatchType\n      priceType\n      simplified\n      conditions {\n        conditionID\n        formula\n        position\n        priceToAdd\n        quantity\n      }\n      targets {\n        targetID\n        area\n        color\n        side\n      }\n    }\n  }\n  pricingProperties {\n    propertyID\n    propertyName\n    functionName\n    elements {\n      elementID\n      elementName\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f5da6157dce1ef9f8e967c5687e9cda";

export default node;
